import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Col, Form, Row } from 'antd';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { selectUser } from '../../../../auth/states/userSlice';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import LoadingIndicator from '../../../../components/common/spinner/LoadingIndicator';
import { useAddClientMutation } from '../api/endpoints/clientEndpoints';
import Client_Add_Edit from '../components/common/Client_Add_Edit';
import { IClientAddFormData } from '../types/clientInterfaces';

const AddClient = () => {
  const location = useLocation();

  const navigate = useNavigate();
  const user = useSelector(selectUser);

  const [form] = Form.useForm();

  const [addClient, { isError, isSuccess, isLoading }] = useAddClientMutation();

  const AddClientSubmitHandle = (values: IClientAddFormData) => {
    const body = {
      values,
      user_full_name: user?.user_full_name,
      client_airline_commissions:
        values?.client_airline_commissions?.map((commission: any) => ({
          ca_airline_id: commission.ca_airline_id || null,
          ca_commission: commission.ca_commission || null,
          ca_markup_charge: commission.ca_markup_charge || null,
        })) || [],
      client_gds_sign:
        values?.client_gds_sign?.map((commission: any) => ({
          gds_name: commission.gds_name || null,
          gds_epr: commission.gds_epr || null,
          gds_creation_sign: commission.gds_creation_sign || null,
        })) || [],
    };

    body.values.client_created_by = user?.user_id as number;
    addClient(body);
  };

  const path = location?.state || '/clients';
  useEffect(() => {
    if (isSuccess) {
      navigate(path);
    }
  }, [isLoading]);

  isLoading && <LoadingIndicator />;

  return (
    <ClientAddStyle>
      <BreadCrumb arrOfOption={['Add Client']} />

      <Col style={{ marginBottom: '1rem' }}>
        <Link to='/clients'>
          <Button type='primary'>
            <ArrowLeftOutlined />
            Return to Client List
          </Button>
        </Link>
      </Col>

      <Form layout='vertical' form={form} onFinish={AddClientSubmitHandle}>
        <Client_Add_Edit form={form} />
        <Row justify={'end'}>
          <Button loading={isLoading} className='mt-10' type='primary' htmlType='submit'>
            Add Client
          </Button>
        </Row>
      </Form>
    </ClientAddStyle>
  );
};

export default AddClient;

const ClientAddStyle = styled.div``;
